// loads scripts that need to be on page - every entrypoint should import this!
import { AdLoader, lazyload } from '@datagraphics/cookbook';
// import * as fs from "fs";

document.addEventListener('DOMContentLoaded', () => {
  // Kickstart image lazy loading
  lazyload();
  // Kickstart ads
  const adLoader = new AdLoader({ adSection: window.AD_SECTION });
  adLoader.init();
});

//packages
import { renderSvelteComponent } from './utils/render.js';
import { json, csv } from 'd3-fetch';
import { timeParse, utcParse } from 'd3-time-format';

//components
import RequestDots from './components/RequestDots.svelte';
import LineChart from './components/LineChart.svelte';
import BarChart from './components/BarChart.svelte';

// 211 Bar chart data
let calls = [
  {year: "2018", value: 471296},
  {year: "'19", value: 481475},
  {year: "'20", value: 671522},
  {year: "'21", value: 673556},
  {year: "'22", value: 564348}
];

let employees = [
  {year: "2018", value: 48.5},
  {year: "'19", value: 48.5},
  {year: "'20", value: 58.5},
  {year: "'21", value: 63.5},
  {year: "'22", value: 48.5}
];

let aban_rate = [
  {year: "2018", value: 0.166},
  {year: "'19", value: 0.214},
  {year: "'20", value: 0.219},
  {year: "'21", value: 0.164},
  {year: "'22", value: 0.166}
];

async function main(){

  const nodes_url = new URL('../_data/nodes.json', import.meta.url);
  const nodes_data = await json(nodes_url);

  const formula_url = new URL('../_data/formula_data.csv', import.meta.url);
  const formula_data = await csv(formula_url, function(d){
    return { date : timeParse("%Y-%m-%d")(d.date), value : +d.year_change }
  });

  const mortgage_url = new URL('../_data/mortgage_data.csv', import.meta.url);
  const mortgage_data = await csv(mortgage_url, function(d){
    return { date : timeParse("%Y-%m-%d")(d.date), value : +d.pctdiff }
  });

  const sc_url = new URL('../_data/santa_cruz_data.csv', import.meta.url);
  const sc_data = await csv(sc_url, function(d){
    return { date : timeParse("%Y-%m-%d")(d.date), value : +d.year_change }
  });

  const shelter_ar_url = new URL('../_data/shelter_ar.csv', import.meta.url);
  const shelter_ar_data = await csv(shelter_ar_url, function(d){
    return { date : timeParse("%Y-%m-%d")(d.date), value : +d.year_change }
  });

  const shelter_wi_url = new URL('../_data/shelter_wi.csv', import.meta.url);
  const shelter_wi_data = await csv(shelter_wi_url, function(d){
    return { date : timeParse("%Y-%m-%d")(d.date), value : +d.year_change }
  });

  renderSvelteComponent(
    RequestDots,
    /** @type {HTMLElement} */ (document.getElementById('dot-requests-container')),
    { nodes: nodes_data }
  );

  renderSvelteComponent(
    LineChart,
    /** @type {HTMLElement} */ (document.getElementById('line-1-container')),
    { data: formula_data,
      annotation_lines: [{date: timeParse("%Y-%m-%d")("2022-05-01"), label: "Congress introduced infant formula bill"}],
      // https://www.congress.gov/bill/117th-congress/house-bill/7790/actions
      // https://www.congress.gov/bill/117th-congress/house-bill/7791
      annotation_ranges: [{
        start_date: timeParse("%Y-%m-%d")("2022-01-01"), 
        end_date: timeParse("%Y-%m-%d")("2022-03-01"), 
        label: "Starting in Jan. 2022, calls were over 30% higher"}]
     }
  );

  renderSvelteComponent(
    LineChart,
    /** @type {HTMLElement} */ (document.getElementById('line-2-container')),
    { data: mortgage_data,
      annotation_lines: [{date: timeParse("%Y-%m-%d")("2007-06-01"), label: "Collapse of Bear Stearns mortgage backed hedge funds"},
      {date: timeParse("%Y-%m-%d")("2008-03-01"), label: "Collapse of Bear Stearns"}],
      // https://www.cnn.com/2018/09/30/investing/bear-stearns-2008-crisis-jimmy-cayne/index.html
      annotation_ranges: [{
        start_date: timeParse("%Y-%m-%d")("2007-01-01"), 
        end_date: timeParse("%Y-%m-%d")("2007-04-01"), 
        label: "Increase in calls"}] }
  );

  renderSvelteComponent(
    LineChart,
    /** @type {HTMLElement} */ (document.getElementById('line-4-container')),
    { data: shelter_ar_data,
      annotation_lines: '',
      annotation_ranges: '' }
  );

  renderSvelteComponent(
    LineChart,
    /** @type {HTMLElement} */ (document.getElementById('line-6-container')),
    { data: shelter_wi_data,
      annotation_lines: '',
      annotation_ranges: '' }
  );

  renderSvelteComponent(
    LineChart,
    /** @type {HTMLElement} */ (document.getElementById('santa-cruz-container')),
    { data: sc_data,
      annotation_lines: [{date: timeParse("%Y-%m-%d")("2020-08-16"), label: "CZU Lightning Complex fires started"}],
      annotation_ranges: [{
        start_date: timeParse("%Y-%m-%d")("2022-01-01"), 
        end_date: timeParse("%Y-%m-%d")("2022-03-01"), 
        label: ""}] }
  );

  renderSvelteComponent(
    BarChart,
    /** @type {HTMLElement} */ (document.getElementById('bars-211la-container')),
    { data_calls: calls,
      data_employees: employees,
      data_aban_rate: aban_rate,
       }
  );

}

main();